let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("f5ExK")).then(() => parcelRequire('lysGq'));